import { Component } from "react";
import OverlayedButton from "./overlayed-button";

export default class Static extends Component {
  render() {
    return <OverlayedButton
      {...this.props}
      tooltip={this.props.tooltip ?? `${this.props.caption.toLowerCase()}`}
    />
  }
}